import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';

import { DefaultButton } from 'common/components';
import { DepositsIcon } from 'common/components/tables/PaymentsTable/Icons';
import { currencyMap } from 'common/constants/payments';
import { withTheme } from 'common/styling/theme';

import { getDynamicStyles, staticStyles } from './style';

const WalletInfoBlock = ({
  walletLogin,
  currency,
  balance,
  isDepositEnabled,
  internalTransfersEnabled,
  isWithdrawEnabled,
  theme,
}) => {
  const history = useHistory();
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  return (
    <div className="WalletInfoBlock">
      <div className="WalletInfoBlock__info">
        <div className="WalletInfoBlock__info_col">
          <FormattedMessage id="justCurrency">
            {txt => <span className="WalletInfoBlock__info_col__title">{txt}</span>}
          </FormattedMessage>
          <div className="WalletInfoBlock__info_col__content">
            <div className="WalletInfoBlock__currency">{currencyMap[currency]}</div>
            <div className="WalletInfoBlock__currency__title">{currency}</div>
          </div>
        </div>
        <div className="WalletInfoBlock__info_col">
          <FormattedMessage id="justLogin">
            {txt => <span className="WalletInfoBlock__info_col__title">{txt}</span>}
          </FormattedMessage>
          <div className="WalletInfoBlock__info_col__content">
            <div className="WalletInfoBlock__login">{walletLogin}</div>
          </div>
        </div>
        <div className="WalletInfoBlock__info_col">
          <FormattedMessage id="justBalance">
            {txt => <span className="WalletInfoBlock__info_col__title">{txt}</span>}
          </FormattedMessage>
          <div className="WalletInfoBlock__balance WalletInfoBlock__info_col__content">
            <div className="WalletInfoBlock__balance__icon">
              <DepositsIcon />
            </div>
            <div className="WalletInfoBlock__balance__title">
              {balance?.amount} {balance?.currency}
            </div>
          </div>
        </div>
      </div>
      <div className="WalletInfoBlock__buttons">
        {isDepositEnabled && (
          <DefaultButton textId="justDeposit" onClick={() => history.push('/deposit/')} type="button" filled />
        )}
        {isWithdrawEnabled && (
          <DefaultButton
            textId="justWithdraw"
            onClick={() => history.push('/withdraw/')}
            type="button"
            disabled={balance?.amount <= 0}
          />
        )}
        {internalTransfersEnabled && (
          <DefaultButton
            textId="boInternalTransfer"
            type="button"
            onClick={() => history.push('/internalTransfer/')}
            disabled={balance?.amount <= 0}
          />
        )}
      </div>
      <style jsx>{dynamicStyles}</style>
      <style jsx>{staticStyles}</style>
    </div>
  );
};

WalletInfoBlock.propTypes = {
  walletLogin: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  balance: PropTypes.object.isRequired,
  isDepositEnabled: PropTypes.bool.isRequired,
  isWithdrawEnabled: PropTypes.bool.isRequired,
  internalTransfersEnabled: PropTypes.bool.isRequired,
  theme: PropTypes.object,
};

WalletInfoBlock.defaultProps = {
  theme: {},
};

export default compose(
  withTheme(),
  connect(state => ({
    isDepositEnabled: state.interfaceConfig.paymentSettings.isDepositEnabled,
    isWithdrawEnabled: state.interfaceConfig.paymentSettings.isWithdrawEnabled,
    internalTransfersEnabled:
      state.interfaceConfig.internalTransfers.accounts_enabled ||
      state.interfaceConfig.internalTransfers.traders_enabled ||
      state.interfaceConfig.internalTransfers.from_wallet_enabled ||
      state.interfaceConfig.internalTransfers.to_wallet_enabled ||
      state.interfaceConfig.internalTransfers.from_wallet_account_enabled ||
      state.interfaceConfig.internalTransfers.to_wallet_account_enabled,
  }))
)(WalletInfoBlock);

export { WalletInfoBlock };
